import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {SanGameAssets} from "./SanGameAssets";
import {SanGameModuleConfig} from "./SanGameModuleConfig";
import {SoundConfig} from "./SoundConfig";
import {SoundManager} from "./resource/sound/SoundManager";

export class SanQuentinPromoPanelConfig implements PromoPanelGameConfiguration {
    private wasFeatureBuy: boolean = false;

    constructor() {
    }

    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "Mental",
            hasActionSpin: true,
            graphics: {backgroundTextureName: SanGameAssets.MAIN_GAME_BACKGROUND},
            getParsedData: (response: any, bet: number, prevResponse: any): ASWinData => {


                if (response.wasFeatureBuy === true) {
                    this.wasFeatureBuy = response.wasFeatureBuy
                } else {
                    if (response.mode == "NORMAL" && response.nextMode == "NORMAL") {
                        this.wasFeatureBuy = false;
                    }
                }

                const parsedData: ASWinData = {
                    totalWin: response.accumulatedRoundWin,
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: response.freespinTriggeredThisSpin,
                    totalSpinWinnings: response.totalBetWayWinnings,
                    isBigWin: this.isBigWin(response),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: response.brokeTheBank,

                }
                return parsedData;
            }
        };
    }

    public onActionSpinPlaySound(trigger: ActionSpinSound): void {
        if (trigger == ActionSpinSound.WIN) {
            SoundManager.playSoundEffect(SoundConfig.AS_WIN);
        } else if (trigger == ActionSpinSound.BIG_WIN) {
            SoundManager.playSoundEffect(SoundConfig.AS_WIN_BIG);
        }
    }

    private isBigWin(response: any): boolean {
        let win = response.totalBetWayWinnings;

        if (this.wasFeatureBuy) {
            const betPrice: number = SanGameModuleConfig.featurePrice.getFeaturePrice();
            let winRatio: number = Helper.ceilToDecimals((win / betPrice), 4);
            return winRatio >= 1;
        }


        let winRatio: number = Helper.ceilToDecimals((win / response.playedBetValue), 4);
        return winRatio >= 15;
    }

    private getFeatureName(response: any): string {

        if ((response.mode == "FREESPIN_SETUP") || response.nextMode == "FREESPIN_SETUP") {
            return "LOCKDOWN SPINS";
        }

        if ((response.mode == "FREESPIN") || response.nextMode == "FREESPIN") {
            return "LOCKDOWN SPINS";
        }

        return response.mode;
    }

    private isRoundComplete(response: any): boolean {
        return true;
    }

    private isBonusEnd(response: any): boolean {
        return (response.nextMode === "NORMAL") && (response.nextMode === "FREESPIN");
    }

}